<template>
    <div class="float_bar">
        <div><a href="http://1.62.163.250:49001/" target="_blank"><i class="icon icon_oa"></i><br />OA登录</a></div>
        <div><a href="http://mail.corner.com.cn:6080/" target="_blank"><i class="icon icon_mail1"></i><br />企业邮箱</a></div>
        <div><a href="javascript:void(0);" @click.stop="goTo('Contact')"><i class="icon icon_kefu"></i><br />在线留言</a></div>
        <!-- <div><i class="icon icon_shop"></i><br />凯纳商城</div>>-->
        <!-- <div><i class="icon icon_wechat"></i><br />关注凯纳</div> -->
        <div><a href="javascript:void(0);" @click.stop="goTo('Map')"><i class="icon icon_contact"></i><br />联系我们</a></div>
        <div class="gotop"><a href="javascript:void(0);" @click="go_top();"><i class="icon icon_gotop"></i><br />回到顶部</a></div>

    </div>
</template>

<script>

export default {
    data() {
        return {
            isShow: '',
            scrollTop:'',
        }; 
    },
    created() {
    },
    mounted() {
        $(window).scroll(function(){      
            if($(window).scrollTop() >= 100){
                $(".banner1").css("height","100px");
                //$(".menu").css("opacity","0.95");
                $(".menu").css("backgroundColor","rgba(255, 255, 255,0.85)");
                $(".menu").css("backgroundPosition","right -1000px top 0px");

                $('.gotop').fadeIn(300); 
            }else{    
                $(".banner1").css("height","300px");
                //$(".menu").css("opacity","1");
                $(".menu").css("backgroundColor","rgba(255, 255, 255,1)");
                $(".menu").css("backgroundPosition","right 0px top 0px");
                $('.gotop').fadeOut(300);    
            }  
        });
    },
    methods: {
        goTo(e) {
            //跳转页面
            this.$router.push(e);
        },
        go_top(){ //回到页面顶部
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
    },
};
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/FloatBar.vue